const default_model = () => (
  { is_alive : true, permissions : 'Owner', is_del : false, parent_id : null, parent_username : '', tax : 0.00, allow_invoice : false }
);

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

import codes from '@/codes';
import reg from '@/reg';
// import { Api } from '@/service';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import moment from 'moment-timezone';

// another vue
import groupList from '../../group/group.List.i18n'
import partnerList from '../partner.List.i18n'
import logLoginList from '../../../Log/login/login.Partner.List.i18n'
import logActionList from '../../../Log/action/action.Partner.List.i18n'
import SettingService from  '../../../System/setting/setting.Service.i18n'
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy

// invoice
import InvoicePartnerList from '../../../Billing/invoice.partner/invoice.partner.List.i18n'
import VueMonthlyPicker from 'vue-monthly-picker'

//restful api
import { partner as manager } from '@/service/api/manager'

export default {
  props : ["partner", 'partner_id'],
  watch: {
    '$route' (to, from) { this.get(to.params, "from", from); },
    partner() {
      console.log("watch updated props data")
      this.model = this.partner
      let is_done_country = false;
      codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

      let is_done_language = false;
      codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

      let is_done_timezone = false;
      codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
    }
  },
  components: {
    VueMonthlyPicker,
    InvoicePartnerList,
    PictureInput,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
    logActionList,
    partnerList,
    SettingService
  },
  data : () => {
		return {
      ticket_invoice_month : '',
      confirm_ticket_invoice : false,
      logo : '',
      publish_list : [],
      published_list : [],
      new_service_id : 0,
      service_append_confirm : false,
      mail_confirm : false,
      is_registed : false,
      index : 0,
      credit_history_opt : default_opt(),
      Credit_Add : false,
      credit_history_modal : false,
      Credit_History : undefined,
      amount : 0.00,
      amount_log : '',
      setting_modify_confirm : false,
      setting_modify : false,
      setting_modify_index : -1,
      partner_price : [],
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : Object.assign({}, default_model()),
      allowed: false,
      partner_connect_modal : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
      published : false
    }
  },
  computed: {
  },
  methods: {
    async get() {
      this.model = default_model()
      console.log(this.partner_id, 'this.partner_id')
      if(!this.partner_id) { return this.$toastr.e('incorrect target partner') }

      try{
        this.add = false;
        if(this.partner) {
          this.model = this.partner;
        } else {
          // let rs = await Api.Manager_Call('partner', 'detail', { id : this.partner_id })
          let rs = await manager.detailPartner({ id : this.partner_id })
          if(rs.error) { return this.$toastr.e("load failed", this.$route.name); }
          this.model = Object.assign({ group: {} }, this.model, rs.body)
        }

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        if(this.model.permissions.toLowerCase() == 'owner') {
          this.is_registed = this.model.updated_at == this.model.created_at
        } else { console.log("this partner not owner, so price is lock") }

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('partner_Detail.vue', 'created'); },
  destroyed() { console.log('partner_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('partner_Detail.vue', 'mounted');
    this.get();
  },
}